import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Breadcrumb aligned to the same container edge as SiteHeader’s logo
 * (`container mx-auto px-4`). Do not nest max-width wrappers here.
 */
const PageBreadcrumb = ({ items = [], className = '' }) => (
  <div className={`bg-white/80 backdrop-blur-sm py-4 border-b border-gray-100/80 ${className}`}>
    <div className="container mx-auto px-4">
      <nav className="flex space-x-2 text-sm min-w-0 overflow-hidden" aria-label="Breadcrumb">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <React.Fragment key={`${item.label}-${index}`}>
              {index > 0 && <span className="text-gray-400 shrink-0">/</span>}
              {item.to && !isLast ? (
                <Link
                  to={item.to}
                  className="text-gray-500 hover:text-amber-600 transition-colors shrink-0"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-gray-900 font-medium truncate min-w-0">{item.label}</span>
              )}
            </React.Fragment>
          );
        })}
      </nav>
    </div>
  </div>
);

export default PageBreadcrumb;
